<template>
  <RevStepper
    v-if="activeStepName"
    :active-step="activeStepName"
    :alternative-text-back="i18n(translations.previousPage)"
    :alternative-text-close="i18n(translations.stepperClose)"
    :alternative-text-completed="i18n(translations.stepperCompleted)"
    :alternative-text-current="i18n(translations.stepperCurrent)"
    has-back
    :steps
    @back="handleStepBack"
  />
</template>

<script setup lang="ts">
import { navigateTo, useRoute } from '#imports'
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevStepper } from '@ds/components/Stepper'

import { CHECKOUT } from '~/scopes/checkout/routes-names'
import { GIFT_CARDS } from '~/scopes/gift-cards/routes.constants'

import translations from './Stepper.translations'

const route = useRoute()
const i18n = useI18n()

const steps = [
  {
    name: 'cart',
    label: i18n(translations.cartStep),
  },
  {
    name: 'billing-address',
    label: i18n(translations.billingStep),
  },
  {
    name: 'payment',
    label: i18n(translations.paymentStep),
  },
  {
    name: 'confirmation',
    label: i18n(translations.confirmationStep),
  },
]

const activeStepName = computed(() => {
  const GIFT_CARDS_ACTIVE_STEPS = {
    [CHECKOUT.GIFT_CARDS.BILLING_ADDRESS]: 'billing-address',
    [CHECKOUT.GIFT_CARDS.PAYMENT]: 'payment',
  }

  const activeStep = steps.find(
    (step) => step.name === GIFT_CARDS_ACTIVE_STEPS[route.name as string],
  )

  return activeStep?.name
})

const handleStepBack = async () => {
  const GIFT_CARDS_PREVIOUS_ROUTES = {
    [CHECKOUT.GIFT_CARDS.BILLING_ADDRESS]: GIFT_CARDS.INDEX,
    [CHECKOUT.GIFT_CARDS.PAYMENT]: CHECKOUT.GIFT_CARDS.BILLING_ADDRESS,
  }

  await navigateTo({ name: GIFT_CARDS_PREVIOUS_ROUTES[route.name as string] })
}
</script>
